import { Outlet } from "react-router-dom";
import BottomCompletionBar from "./components/common/BottomCompletionBar";
import BottomNav from "./components/common/BottomNav";

export default function AppShell() {
    return (
        <div className="min-h-screen bg-white font-suit">
            <Outlet />
            <BottomCompletionBar offsetBottom="env(safe-area-inset-bottom)" />
        </div>
    );
}
